import classNames from "classnames";
import styles from "../../styles/SlateEditor.module.scss";
import Button from "../../../utilities/Button";

export const ButtonWrapper = (props: {
    className?: string,
    pressed?: boolean,
    tooltip?: string,
    [restProps: string]: any,
}) => {
    const {className = "", pressed = false, ...restProps} = props;
    const buttonClassName = classNames({
        [styles.button]: true,
        [styles.buttonWithTooltip]: !!props.tooltip,
        [styles.buttonActive]: pressed,
        [className]: className,
    });

    return <Button {...restProps} data-content={props.tooltip} data-plate-focus className={buttonClassName}/>;
};